<template>
  <div v-if="isMounted">
    <home-section
      id="home-section"
      currentPage="menu"
      :cart="cart"
    ></home-section>
    <div v-if="selectedLocation">
      <sub-menu-navbar
        style="height:43px"
        id="sub-menu-navbar"
        @buttonClicked="tabToDisplay"
      ></sub-menu-navbar>
      <search-nav-bar id="search-bar"></search-nav-bar>
      <small-categories-section
        :categories="filteredData"
        :active-category="activeCategory"
        @setActiveCategory="onSetActiveCategory"
      ></small-categories-section>
      <section class="section section-menu" id="menu-section">
        <div class="container">
          <div class="row">
            <categories-section
              ref="categogyParentElement"
              :categories="filteredData"
              :active-category="activeCategory"
              @setActiveCategory="onSetActiveCategory"
            ></categories-section>
            <menu-section
              id="section-menu"
              :tabName="tab"
              :categories="filteredData"
              :favorites="filterFavoriteData"
              :specials="filtredSpecialData"
              :cart="cart"
            ></menu-section>
            <checkout-section
              :hide="true"
              :action="btnAction"
              :cart="cart"
            ></checkout-section>
          </div>
        </div>
      </section>
      <order-modal
        ref="itemModal"
        :fromItem="fromItem"
        :editMode="editMode"
        :index="index"
        :orderType="cart.orderType"
      ></order-modal>
      <order-changes-confirmation
        ref="popupConfirmation"
      ></order-changes-confirmation>
    </div>
    <div v-else>
      <empty-data
        :message="$t('empty.no_location_selected')"
        icon="k-icon-home"
        iconColor="#738290"
        textColor="#22223B"
      ></empty-data>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import {
  HomeSection,
  CategoriesSection,
  CheckoutSection,
  MenuSection,
  OrderModal,
  SmallCategoriesSection,
  EmptyData,
} from "@/views/components";
import {
  SubMenuNavbar,
  SearchNavBar,
  OrderChangesConfirmation,
} from "@/layout";

import { helpers, cartManager, enumHelper } from "@/utilities";
import couponMixin from "../mixins/couponMixin";
export default {
  name: "location-menu",
  mixins:[couponMixin],
  bodyClass: "menu-page",
  components: {
    HomeSection,
    SubMenuNavbar,
    CategoriesSection,
    CheckoutSection,
    MenuSection,
    OrderModal,
    SmallCategoriesSection,
    EmptyData,
    OrderChangesConfirmation,
    SearchNavBar,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    locationStatus: function() {
      return helpers.canMakeOrder(this.selectedLocation, this.isMounted);
    },
    filteredData: function() {
      if (this.tab == "menu") {
        return helpers.$_find(
          this.locationMenuItems,
          this.searchTerm,
          this.tab,
          this.cart.orderType,
          helpers.filterBy
        );
      }
      return null;
    },
    filterFavoriteData: function() {
      if (this.user && this.tab == "fav") {
        return helpers.$_find(
          this.locationMenuItems,
          this.searchTerm,
          this.tab,
          this.cart.orderType,
          helpers.filterBy
        );
      }
      return null;
    },
    filtredSpecialData: function() {
      const { selectedLocation, searchTerm, tab, cart } = this;
      if (tab == "menu") {
        return helpers.$_findSpecial(
          selectedLocation.specials,
          searchTerm,
          cart.orderType
        );
      }
      return null;
    },
  },
  data() {
    return {
      fromItem: null,
      editMode: false,
      index: -1,
      tab: "menu",
      btnAction: enumHelper.actions.CHECKOUT,
      counterClick: 0,
      searchTerm: "",
      confirmedPopup: false,
      isMounted: false,
      cart: cartManager.InitCart(),
      continueProcessing: true,
      activeCategory:"special"
    };
  },
  methods: {
    ...mapActions(["fetchCategories"]),
    addItemToOrder(_currentItem, _openModal = false) {
      //---- if the location is closed and allow futur_accept_orders , popup is displayed
      const {
        can_accept_delivery,
        can_accept_collection,
        openingHours,
      } = this.locationStatus;

      if (
        (this.cart.orderType == enumHelper.orderType.Delivery &&
          !this.locationStatus.can_accept_delivery) ||
        (this.cart.orderType == enumHelper.orderType.Collection &&
          !this.locationStatus.can_accept_collection) ||
        (this.cart.orderType == enumHelper.orderType.Table &&
          !this.locationStatus.can_accept_tableOrdering)
      ) {
        if (this.counterClick >= 4) {
          this.$notify({
            group: "bottomRight",
            title: this.$t('message.no_orders_title'),
            type: "warn",
            text: this.$t('message.location_not_taking_orders', {location_name : this.selectedLocation.name})
          });
        }
        this.counterClick++;
        return;
      }

      if (
        this.confirmedPopup === false &&
        ((this.cart.orderType == enumHelper.orderType.Delivery &&
          !openingHours.delivery &&
          can_accept_delivery) ||
          (this.cart.orderType == enumHelper.orderType.Collection &&
            !openingHours.collection &&
            can_accept_collection))
      ) {
        let message = this.$t('message.pre_order_confirmation', { location_name : this.selectedLocation.name })
        let options = {
          html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          okText: this.$t('button.confirm'),
          cancelText: this.$t('button.no_thanks'),
          animation: "fade", // Available: "zoom", "bounce", "fade"
          type: "basic", // coming soon: 'soft', 'hard'
          verification: "continue", // for hard confirm, user will be prompted to type this to enable the proceed button
          //verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
          clicksCount: 1, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
          backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
          customClass: "confirm", // Custom class to be injected into the parent node for the current dialog instance
        };

        this.$dialog
          .confirm(message, options)
          .then(() => {
            this.confirmedPopup = true;
            this.callbackAddItem(_currentItem, _openModal);
          })
          .catch(() => {
            this.continueProcessing = false;
          });
      } else {
        this.callbackAddItem(_currentItem, _openModal);
      }
      this.addEventListener();
    },
    callbackAddItem(_currentItem, _openModal) {
      if (_openModal) {
        if (!this.editMode) {
          this.fromItem = JSON.parse(JSON.stringify(_currentItem));
          this.fromItem.quantity = 1;
          if (this.fromItem.hasOptions) {
            this.fromItem.options.forEach((element) => {
              if (element.type == "SELECT" || element.type == "RADIO"){
                element.selected = "";
              }  
              else {
                element.selected = [];
              }
              element.comment = "";
            });
          }
        } else {
          this.fromItem = _currentItem;
        }
        //--- geive the Modal the Data and Open-it
        this.$refs.itemModal.openModal();
      } else {
        this.pushOrder(_currentItem);
        this.applyAutoCoupon();
        cartManager.setCart(this.cart);
        this.$nextTick(() => {
          this.setCartDeliveryFee();
          this.$notify({
            group: "bottomRight",
            title: this.editMode ? this.$t('message.item_updated') : this.$t('message.item_added'),
            type: "success",
            text: this.editMode ? this.$t('message.item_updated_message', {item_name : _currentItem.name}) : this.$t('message.item_added_message', {item_name : _currentItem.name}),
          });
          //--- set Total
          this.$refs.itemModal.closeModal();
        });
      }
    },
    setPopupTrue() {
      this.confirmedPopup === true;
    },
    pushOrder(item) {
      //--- check if a coupon is not already applied => apply auto-coupon
      let exist = false;
      let k = 0;
      if (this.cart.order.length <= 0) {
        if (!item.hasOptions) item.quantity = 1;

        this.cart.order.push(item);
        return;
      }

      while (k < this.cart.order.length && !exist) {
        // ||
        if (
          this.cart.order[k].id == item.id &&
          JSON.stringify(this.cart.order[k].options) ===
            JSON.stringify(item.options)
        ) {
          if (!this.editMode) {
            if (!item.hasOptions) {
              this.cart.order[k].quantity++;
            } else {
              this.cart.order[k].quantity =
                this.cart.order[k].quantity + item.quantity;
            }
          }
          exist = true;
          return;
        }
        k++;
      }
      if (!exist) {
        if (!item.hasOptions) {
          item.quantity = 1;
        }
        this.cart.order.push(item);
      }
    },
    removeItem(_index) {
      //---- get the card
      let itemToDelete = this.cart.order[_index];
      this.$delete(this.cart.order, _index);

      cartManager.setCart(this.cart);
      this.$nextTick(() => {
        this.setCartDeliveryFee();
      });
      this.$notify({
        group: "bottomRight",
        title: this.$t('message.item_removed_notify_title'),
        type: "warn",
        text: this.$t('message.item_removed_from_order', {item_name : itemToDelete.name })
      });

      if (this.editMode) this.$refs.itemModal.closeModal();
      this.removeEventListner();
    },
    removeItems(arrItems){
      //---- get the card
      this.cart.order = this.cart.order.filter(x => !arrItems.includes(x.id));

      cartManager.setCart(this.cart);
      this.$nextTick(() => {
        this.setCartDeliveryFee();
      });
      this.removeEventListner();
    },
    addEventListener: function() {
      this.$root.$off("PUSH_ITEM");
      this.$root.$on("PUSH_ITEM", (_object) => {
        this.index = _object.index;
        this.editMode = _object.editMode;
        this.addItemToOrder(_object.item, _object.openModal);
      });
    },
    openPopUpConfirmationEventListner: function() {
      this.$root.$off("OPEN_POPUP_CONFIRMATION");
      this.$root.$on("OPEN_POPUP_CONFIRMATION", (data) => {
        this.$refs.popupConfirmation.ItemsNotAvailable = data.ItemsNotAvailable;
        this.$refs.popupConfirmation.ItemsWithDiffPrice =
          data.ItemsWithDiffPrice;
        this.$refs.popupConfirmation.shown = true;
        this.$refs.popupConfirmation.newOrderType = data.NewOrderType;
        this.$refs.popupConfirmation.oldOrderType = data.OldOrderType;
      });
    },
    removeEventListner: function() {
      this.$root.$off("REMOVE_ITEM");
      this.$root.$on("REMOVE_ITEM", (_index) => {
        this.removeItem(_index);
      });
      
      this.$root.$off("REMOVE_ITEMS");
      this.$root.$on("REMOVE_ITEMS", (arrItems) => {
        this.removeItems(arrItems);
      });
    },
    tabToDisplay: function(_tabName) {
      this.tab = _tabName;
    },
    searchEventListner: function() {
      this.$root.$off("SEARCH_ITEMS");
      this.$root.$on("SEARCH_ITEMS", (term) => {
        this.searchTerm = term;
      });
    },
    setCartDeliveryFee() {
      return new Promise((resolve) => {
        if (
          this.cart.orderType == enumHelper.orderType.Delivery &&
          this.selectedLocation.delivery_condition &&
          this.selectedLocation.availabe_delivery_postcode
        ) {
          if (this.cart.order.length)
            // call this method if the cart total is > to 0
            this.cart.delivery_fee = helpers.getDeliveryFee(
              this.selectedLocation.delivery_condition,
              this.cart.total
            );
          else {
            this.cart.delivery_fee = helpers.getDefaultDeliveryFee(
              this.selectedLocation.delivery_condition
            );
          }
          cartManager.setCart(this.cart, true, false);
          resolve(true);
        }
        resolve(false);
      });
    },
    applyAutoCoupon() {
      if ((!this.cart.coupon_result && !this.cart.coupon) && this.user) {
        let autoCoupon = helpers.checkforAutoCoupon(this.selectedLocation);
        this.cart.coupon = autoCoupon ? autoCoupon.code : "";
        if(this.cart.coupon.length){
          this.onSubmitAutoCoupon();
        }
      }
    },
    refreshCartDataListner(){
      this.$root.$off("REFRESH_CART_DATA");
      this.$root.$on("REFRESH_CART_DATA", () => {
        this.cart = cartManager.getCart();
      });
    },
    onSetActiveCategory(value){
      this.$set(this,'activeCategory', value)
    }
  },
  created: function() {
    this.refreshCartDataListner();
    this.addEventListener();
    this.removeEventListner();
    this.searchEventListner();
    this.openPopUpConfirmationEventListner();

     this.activeCategory = (this.filtredSpecialData && this.filtredSpecialData.length) ? "special" :  
          this.locationMenuItems && this.locationMenuItems.length ? this.locationMenuItems[0].id : null;

     this.cart = cartManager.InitCart();
  },
  mounted() {
    if(!this.selectedLocation){
      this.$router.push({name:'home'})
    }
    this.refreshLocationData();
    this.isMounted = true;
    // if the cart is already saved , do not save-it
    this.setCartDeliveryFee().then((result) => {
      if (!result) cartManager.setCart(this.cart, true, false);
    });

    //---- save the selected location id , in the cart
    this.cart.locationId = this.selectedLocation.id;
    cartManager.setCart(this.cart, false, false);
    this.applyAutoCoupon();
  }
};
</script>
